// export const SIGNAL_SERVER_URL = "ws://localhost:4000"
export const SIGNAL_SERVER_URL = "wss://offchain.mc-infra.com"
export const MESSAGE = "mc"